import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { ref: "topics" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.topics.private_topics')
};
import { storeToRefs } from 'pinia';
import Topics from '@/components/topics/Topics.vue';
import SkeletonTopic from '@/components/topics/SkeletonTopic.vue';
import transitions from '@/helpers/transitions';
import { useRetroStore } from '@/pinia_stores/retro';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'PrivateTopics',
    setup(__props) {
        const retroStore = useRetroStore();
        const { ownPrivateTopics, phase, maxTopics, loadingStatuses } = storeToRefs(retroStore);
        const { startSharingTopic, stopSharingTopic } = retroStore;
        function handleDrag(event) {
            const topicId = Number(event.item.attributes.id.value);
            startSharingTopic({ topicId, mode: 'drag' });
        }
        function handleDragEnd(event) {
            if (event.from === event.to) {
                stopSharingTopic();
            }
        }
        function allowDrop(_to, _from, element) {
            const privateIds = ownPrivateTopics.value.map((topic) => topic.id);
            return privateIds.includes(parseInt(element.id));
        }
        const { fadeIn, fadeOut } = transitions.fade;
        return (_ctx, _cache) => {
            const _component_transition_a11y = _resolveComponent("transition-a11y");
            const _component_paragraph = _resolveComponent("paragraph");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createVNode(_component_transition_a11y, {
                    css: false,
                    onEnter: _unref(fadeIn),
                    onLeave: _unref(fadeOut)
                }, {
                    default: _withCtx(() => [
                        _createVNode(Topics, {
                            topics: _unref(ownPrivateTopics),
                            "allow-drop": allowDrop,
                            stacked: true,
                            class: "relative w-full",
                            onDrag: handleDrag,
                            onDragEnd: handleDragEnd
                        }, null, 8, ["topics"])
                    ], undefined, true),
                    _: 1
                }, 8, ["onEnter", "onLeave"]),
                (_unref(loadingStatuses).has('newPrivateTopic'))
                    ? (_openBlock(), _createBlock(SkeletonTopic, { key: 0 }))
                    : _createCommentVNode("", true),
                (_unref(phase) === 'writing' && _unref(maxTopics))
                    ? (_openBlock(), _createBlock(_component_paragraph, {
                        key: 1,
                        class: "mr-10 italic text-center"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('write_up_to_n', { n: _unref(maxTopics) })), 1)
                        ], undefined, true),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ], 512));
        };
    }
});
